import "./CarMakersBanner.css";

const CarMakersBanner = () => {
  return (
    <section className="car-makers-banner" aria-labelledby="car-makers-banner-title">
      <div className="car-makers-banner__content">
        <h2 id="car-makers-banner-title" className="car-makers-banner__title">
          Рады сообщить!
        </h2>
        <p className="car-makers-banner__description">
          Теперь вы можете приобрести у нас запчасти на любые марки авто!
          <br />
          Свяжитесь с менеджером в удобном магазине
        </p>
        <a className="car-makers-banner__button" href="#store-map">
          Перейти к контактам
        </a>
      </div>

      <div className="car-makers-banner__logos" aria-hidden="true">
        <div className="car-makers-banner__logos-track">
          <img src="/images/carmakers_logos.webp" alt="" />
          <img src="/images/carmakers_logos.webp" alt="" />
        </div>
      </div>
    </section>
  );
};

export default CarMakersBanner;
